(function () {
  if (window.westySlidersInstalled) return;
  window.westySlidersInstalled = true;
  function init(root) {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = 'true';
    var slides = Array.from(root.querySelectorAll('[data-slider-slide]'));
    if (slides.length < 2) return;
    var dots = Array.from(root.querySelectorAll('[data-slider-dot]'));
    var pause = root.querySelector('[data-slider-pause]');
    var media = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var paused = root.dataset.autoplay === 'false' || media.matches;
    var hover = false;
    var pauseOnHover = !root.classList.contains('wh-main-slider') && !root.classList.contains('wh-announcement');
    var focused = false;
    var timer;
    var interval = Math.max(4000, Number(root.dataset.interval) || 6000);
    function stop() { window.clearTimeout(timer); }
    function schedule() {
      stop();
      if (root.isConnected && !paused && !hover && !focused && !document.hidden) {
        timer = window.setTimeout(function () { show(index + 1); }, interval);
      }
    }
    function updatePause() {
      if (!pause) return;
      pause.dataset.paused = String(paused);
      pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
    }
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      schedule();
    }
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
    if (pause) pause.addEventListener('click', function () {
      paused = !paused;
      if (!paused) focused = false;
      updatePause();
      schedule();
    });
    root.addEventListener('click', function (event) {
      if (!root.classList.contains('wh-main-slider')) return;
      if (!event.target.closest('[data-slider-slide]')) return;
      if (event.target.closest('a, button, input, select, textarea, summary')) return;
      paused = true;
      updatePause();
      schedule();
    });
    root.addEventListener('mouseenter', function () { if (pauseOnHover) { hover = true; stop(); } });
    root.addEventListener('mouseleave', function () { hover = false; schedule(); });
    root.addEventListener('focusin', function () { focused = true; stop(); });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { focused = false; schedule(); }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    var start;
    root.addEventListener('touchstart', function (event) {
      if (event.touches.length === 1) start = { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (!start || !event.changedTouches.length) return;
      var dx = event.changedTouches[0].clientX - start.x;
      var dy = event.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      start = null;
    }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    media.addEventListener('change', function (event) {
      if (event.matches) { paused = true; updatePause(); }
      schedule();
    });
    root.addEventListener('shopify:block:select', function (event) {
      var selected = slides.findIndex(function (slide) { return slide.contains(event.target) || slide === event.target; });
      if (selected >= 0) { paused = true; updatePause(); show(selected); }
    });
    updatePause();
    show(0);
  }
  function scan() { document.querySelectorAll('[data-wh-slider]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
